import React from "react";
import Achievements from "./Achievements";
import Education from "./Education";
import Experience from "./Experience";
import PersonalInfo from "./PersonalInfo";
import Skills from "./Skills";
import heroImgMobile from "../../assets/img/hero/img-mobile.jpg";
import bg3 from "../../assets/bg3.jpg"; // Import your background image

const index = () => {
  return (
    <section
      className="main-content"
      style={{
        backgroundImage: `url(${bg3})`, // Set the background image
        backgroundSize: "cover", // Ensure the image covers the whole area
        backgroundPosition: "center", // Center the image
        backgroundRepeat: "no-repeat", // Avoid repetition
        minHeight: "100vh", // Make it full-screen
        color: "white", // Ensure text is readable
        padding: "20px", // Add padding for content
      }}
    >
        <div className="box_inner about">
            <div data-aos="fade-up" data-aos-duration="1200">
              <div className="title-section text-left text-sm-center">
                <h1>
                  ABOUT <span>US</span>
                </h1>
                <span className="title-bg">Resume</span>
              </div>
            
            </div>
          </div>
      <div className="container">
        <div className="row">
          {/* Personal Info Starts */}
          <div className="col-xl-6 col-lg-5 col-12">
            <div className="row">
              <div className="col-12">
                <h3 className="text-uppercase custom-title mb-0 ft-wt-600">
                  Company Info
                </h3>
              </div>

              <div className="col-12 d-block d-sm-none">
                <img
                  src={heroImgMobile}
                  className="img-fluid main-img-mobile"
                  alt="about avatar"
                />
              </div>

              <div className="col-12">
                <PersonalInfo />
              </div>
            </div>
          </div>

          {/* Achievements Starts */}
          <div className="col-xl-6 col-lg-7 col-12 mt-5 mt-lg-0">
            <Achievements />
          </div>
        </div>

        <hr className="separator" />

        {/* Skills Starts */}
        <div className="row">
          <div className="col-12">
            <h3 className="text-uppercase pb-4 pb-sm-5 mb-3 mb-sm-0 text-left text-sm-center custom-title ft-wt-600" style={{fontSize:'50px', fontWeight:'bold'}}>
              Our Services
            </h3>
          </div>
          <Skills />
        </div>

        <hr className="separator mt-1" />

        {/* Experience & Education Starts */}
        <div className="row">
          <div className="col-12">
            <h3 className="text-uppercase pb-5 mb-0 text-left text-sm-center custom-title ft-wt-600" style={{fontSize:'50px', fontWeight:'bold'}}>
              Founders
            </h3>
          </div>
          <div style={{ display: "flex", gap: "15px" }}>
            <div className="">
              <div className="resume-box">
                <Experience />
              </div>
            </div>
            <div className="">
              <div className="resume-box">
                <Education />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default index;
